import React from 'react'
import { createRenderTarget } from '../../render-target'
import loadable from '@loadable/component'

import {
    AutoplayOptions,
    VideoOptions,
    GetVideoQueue,
} from '../../content/Video/PlayerInterface'
import { VideoDetails } from '@news-mono/web-common'

import {
    ArticleImage,
    FigcaptionRenderOptions,
} from '../../publication/ArticleImage/ArticleImage'
import { PlayerEvent } from '@news-mono/web-common'
import { RssArticleVideo } from './ArticleVideo.rss'
import { FeatureToggle } from '../../feature-toggling/Toggle/Toggle'

export const LazyAmpArticleVideo = loadable(() => import('./ArticleVideo.amp'))

export const LazyWebArticleVideo = loadable(() => import('./ArticleVideo.web'))

export interface VideoArticle {
    isHeroVideo?: boolean
    isVideoStickyEnabled?: boolean
    showPlaylist?: boolean
    publicationPathname?: string
}

export interface ArticleVideoProps extends VideoArticle {
    showTitles: boolean
    videoDetails: VideoDetails
    videoOptions: VideoOptions
    autoplayOptions: AutoplayOptions | false
    autoplayNextOptions: AutoplayOptions | false
    pauseOverlay: boolean
    getVideoQueue: GetVideoQueue
    byline?: string
    captionText?: string
    credit?: string
    kind?: string
    figcaptionRenderOptions?: FigcaptionRenderOptions
    onEvent: (event: PlayerEvent) => void
    playButtonText?: string
}

const ArticleVideoRenderTarget = createRenderTarget<ArticleVideoProps>(
    'ArticleVideo',
    {
        web: LazyWebArticleVideo,
        amp: LazyAmpArticleVideo,
        rss: RssArticleVideo,
        preview: LazyWebArticleVideo,
        app: LazyWebArticleVideo,
    },
)
export const ArticleVideo = (props: ArticleVideoProps) => (
    <FeatureToggle
        feature={'brightcove-player'}
        on={() => <ArticleVideoRenderTarget {...props} />}
        off={() => {
            if (!props.videoDetails.posterImage) {
                return null
            }
            return (
                <ArticleImage
                    image={props.videoDetails.posterImage}
                    figCaption={{
                        byline: props.byline,
                        captionText: props.captionText,
                        credit: props.credit,
                        kind: 'image',
                    }}
                    figcaptionRenderOptions={props.figcaptionRenderOptions}
                    isHeroImage={true}
                />
            )
        }}
    />
)

ArticleVideo.displayName = 'ArticleVideo'
